import React from 'react'
import { OrdersetSettingsPageView } from './view'
import { OrdersetSettingsPageLogic } from './logic'
import { ProvidersViewModel } from '../../../viewmodels'

export const OrdersetSettingsPage: React.FC = () => {
  return (
    <OrdersetSettingsPageLogic>
      <OrdersetSettingsPageView />
    </OrdersetSettingsPageLogic>
  )
}
